import { BASIC_LINE } from "../constants/colors";

export default function IconStar() {
  return (
    <svg
      height="28.532"
      viewBox="0 0 30 28.532"
      width="30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m199.472 148.975 4.693 9.313 10.307 1.585-7.407 7.341 1.677 10.293-9.271-4.776-9.271 4.776 1.677-10.293-7.407-7.341 10.307-1.585z"
        fill={BASIC_LINE}
        transform="translate(-184.472 -148.975)"
      />
    </svg>
  );
}
